
<template>
  <div class="page__container">
    <BreadCrumbsTemplate/>
  <div v-if="currentService">
    <h1>{{ currentService.title[locale] }}</h1>
    <p>{{ currentService.description[locale] }}</p>
  </div>
  <div v-else>
    <p>❌ Услуга не найдена!</p>
  </div>
</div>
</template>

<script>
import servicesData from "@/data/services.json";
import BreadCrumbsTemplate from '@/components/BreadCrumbsTemplate.vue';

export default {
  name: "ServiceDetailView",
  components: {
    BreadCrumbsTemplate
  },
  data() {
    return {
      currentTarget: this.$route.params.target,
      currentCategory: this.$route.params.category
    };
  },
  computed: {
    locale() {
      return this.$route.params.locale;
    },
    currentService() {
      console.log(`🔍 Проверяем услугу: ${this.currentTarget} для локали: ${this.locale}`);
      return servicesData.find(service => 
        service.url[this.locale] === this.currentTarget && 
        service.category[this.locale] === this.currentCategory
      ) || null;
    }
  },
  watch: {
    locale: {
      handler(newLocale) {
        console.log(`🌍 Локаль изменилась: ${newLocale}`);
        this.updateTargetForNewLocale(newLocale);
      },
      immediate: true
    }
  },
  methods: {
    updateTargetForNewLocale(newLocale) {
      console.log(`🔄 Начинаем обновление target и category для новой локали: ${newLocale}`);

      const service = servicesData.find(service => Object.values(service.url).includes(this.currentTarget));

      if (service) {
        const newTarget = service.url[newLocale];
        const newCategory = service.category[newLocale];

        if (newTarget && newCategory) {
          console.log(`✅ Обновляем target: ${this.currentTarget} → ${newTarget}`);
          console.log(`✅ Обновляем category: ${this.currentCategory} → ${newCategory}`);

          this.$router.replace({
            params: { locale: newLocale, category: newCategory, target: newTarget }
          });

          this.currentTarget = newTarget;
          this.currentCategory = newCategory;
        } else {
          console.warn(`⚠️ Услуга не имеет данных для локали: ${newLocale}`);
        }
      } else {
        console.warn(`⚠️ Услуга с target ${this.currentTarget} не найдена`);
      }
    }
  }
};
</script>
